var map = {
	"./img_1.jpg": 3926,
	"./img_2.jpg": 85268,
	"./img_3.jpg": 6923,
	"./img_4.jpg": 79642,
	"./img_5.jpg": 34359,
	"./img_6.jpg": 84341,
	"./img_7.jpg": 16402,
	"./img_8.jpg": 72464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35767;